import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="isModal" class="modal-backdrop"></div>
    <div class="toast" [ngClass]="[type, isModal ? 'modal-toast' : '']">
      <div class="toast-header">
        <div class="title-container">
          <span class="toast-icon">{{ type === 'success' ? '✅' : type === 'warning' ? '⚠️' : type === 'info' ? 'ℹ️' : '❌' }}</span>
          <h5 class="toast-title">{{ title }}</h5>
        </div>
        <button class="close-button" (click)="close()">×</button>
      </div>
      <div class="toast-body">
        {{ message }}
      </div>
      <div *ngIf="isModal" class="modal-footer">
        <button class="modal-close-button" (click)="close()">Close</button>
      </div>
    </div>
  `,
  styles: [`
    .toast {
      position: fixed;
      top: 20px;
      right: 20px;
      min-width: 300px;
      max-width: 400px;
      padding: 15px;
      border-radius: 4px;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
      z-index: 9999;
      animation: slideIn 0.3s ease-in-out;
    }
    .toast.error {
      background-color: #f8f9ff;
      border-left: 4px solid #4a90e2;
    }
    .toast.info {
      background-color: #fff;
      border-left: 4px solid #007bff;
    }
    .toast.success {
      background-color: #fff;
      border-left: 4px solid #28a745;
    }
    .toast.warning {
      background-color: #fff;
      border-left: 4px solid #ffc107;
    }
    .toast-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    .title-container {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .toast-icon {
      font-size: 18px;
    }
    .toast-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
    }
    .close-button {
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      padding: 0 5px;
    }
    .toast-body {
      font-size: 14px;
      line-height: 1.4;
    }
    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    /* Modal Toast Styles */
    .modal-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 9998;
      animation: fadeIn 0.3s ease-in-out;
    }
    
    .modal-toast {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      min-width: 400px;
      max-width: 600px;
      width: 90%;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      z-index: 9999;
      animation: fadeIn 0.3s ease-in-out;
      border: none;
    }
    
    .modal-toast.error {
      background-color: #f8f9ff;
      border: 1px solid #4a90e2;
    }
    
    .modal-toast .toast-header {
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
    }
    
    .modal-toast .toast-title {
      color: #4a90e2;
      font-size: 18px;
    }
    
    .modal-toast .toast-body {
      padding: 15px 0;
      font-size: 16px;
    }
    
    .modal-toast .close-button {
      background-color: #f8f9fa;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s;
    }
    
    .modal-toast .close-button:hover {
      background-color: #e9ecef;
    }
    
    .modal-footer {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid #eee;
    }
    
    .modal-close-button {
      background-color: #4a90e2;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      transition: background-color 0.2s;
    }
    
    .modal-close-button:hover {
      background-color: #357abd;
    }
    
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `]
})
export class CustomToastComponent implements OnInit, OnDestroy {
  message: string = '';
  title: string = '';
  duration: number = 5000;
  type: 'error' | 'success' | 'warning' | 'info' = 'error';
  isModal: boolean = false;
  element: HTMLElement;

  constructor(private elementRef: ElementRef) {
    this.element = this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    // Component initialization logic if needed
  }

  ngOnDestroy(): void {
    // Cleanup logic if needed
  }

  close(): void {
    const event = new CustomEvent('toastClose', {
      detail: this
    });
    document.dispatchEvent(event);
  }
  
  showWarning(message: string, title: string = 'Warning', duration: number = 5000, isModal: boolean = false): void {
    this.message = message;
    this.title = title;
    this.duration = duration;
    this.type = 'warning';
    this.isModal = isModal;
  }
} 